/**
 * Reservations module - shared utilities and constants
 */

// Icon mapping for event types
import { Utensils, Car, Sparkles, Mountain, Star } from 'lucide-react';

export const EVENT_ICONS = {
  MEAL: Utensils,
  ACTIVITY: Star,
  TAXI: Car,
  SPA: Sparkles,
  EXCURSION: Mountain,
  OTHER: Star
};

export const formatCurrency = (amount, currency = 'MAD') => {
  return new Intl.NumberFormat('fr-MA').format(amount) + ' ' + currency;
};

// Calculate nights between two dates
export const calculateNights = (checkIn, checkOut) => {
  if (!checkIn || !checkOut) return 0;
  const start = new Date(checkIn);
  const end = new Date(checkOut);
  const diff = end - start;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};
